import React from 'react';
import { getProjectStatusConfig } from '../../../constants/projectConstants';

const ProjectStatusBadge = ({ status, size = 'md' }) => {
  const statusConfig = getProjectStatusConfig(status);
  
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };
  
  return (
    <span className={`
      inline-flex items-center rounded-full font-medium
      ${sizeClasses[size]}
      ${statusConfig.color}
    `}>
      {statusConfig.label}
    </span>
  );
};

export default ProjectStatusBadge;